<template>
  <div class="section" v-if="tokenUser">
    <Header
      :data="header"
      :filter="filter"
      @setFilter="setFilter"
      @setDate="setDate"
    />
    <Content
      :companies="companies"
      :filter="filter"
      @setFilter="setFilter"
      @updateCompany="updateCompany"
      @switchSideMenu="switchSideMenu"
    />
    <transition name="slide">
      <SideMenu
        v-if="showSideMenu"
        :updateData="sideMenuData.updateData"
        :dataValidate="header.companiesValidate"
        @updateCompany="updateCompany"
        @switchSideMenu="switchSideMenu"
        @getCompanies="getCompanies"
      ></SideMenu>
    </transition>
  </div>
</template>
<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
import Header from "./layaout/Header.vue";
import Content from "./layaout/Content.vue";
import SideMenu from "./components/SideMenu.vue";

export default {
  data() {
    return {
      header: {},
      companies: [],
      filter: {},
      date: null,
      showSideMenu: false,
      sideMenuData: {
        updateData: {},
      },
    };
  },
  computed: {
    ...mapState(["idtoken", "isOculto", "tokenUser"]),
  },
  beforeMount() {
    if (!this.isOculto) {
      this.$store.commit("ocultarSide");
    }
  },
  methods: {
    async getCompanies() {
      try {
        const date = this.date;
        const result = await apiServices.get(
          `/empresas1${date ? "/" + date : ""}`
        );
        if (result.data) {
          this.companies = result.data.data;
          this.header = result.data.header;
          /*
                    {
                        _id: 1,
                        nit: 1,
                        nombre: 1,
                        namesearch: 1,
                        direccion: 1,
                        telefono: 1,
                        sector: 1,
                        leader: 1,
                        lastProcessLeader: 1,
                        climaOld: 1,
                        climaOldProcessLeader: 1,
                        clima: 1,
                        climaProcessLeader: 1,
                        cultura: 1,
                        culturaProcessLeader: 1,
                        created: 1
                    }
                    */
        }
      } catch (err) {
        console.log(err);
      }
    },
    setFilter(value) {
      if (
        (Object.keys(this.filter).length && this.filter.value === value) ||
        value === ""
      ) {
        this.filter = {};
      } else {
        this.filter = {
          type: "header",
          value: value,
        };
      }
    },
    setDate(date) {
      this.date = date ? date.getFullYear() : date;
    },
    switchSideMenu() {
      this.showSideMenu = !this.showSideMenu;
      if (
        Object.keys(this.sideMenuData.updateData).length &&
        !this.showSideMenu
      ) {
        this.sideMenuData.updateData = {};
      }
    },
    updateCompany(data) {
      if (data) {
        this.switchSideMenu();
        setTimeout(() => {
          this.sideMenuData.updateData = { ...data };
        }, 200);
      } else {
        this.sideMenuData.updateData = {};
      }
    },
  },
  created() {
    if (this.idtoken) {
      this.getCompanies();
    }
  },
  watch: {
    idtoken(nv) {
      if (nv) {
        this.getCompanies();
      }
    },
    date() {
      this.getCompanies();
    },
  },
  components: {
    Header,
    Content,
    SideMenu,
  },
};
</script>
<style lang="scss" scoped></style>
<style lang="scss">
// Slide
.slide-enter {
  transform: translateX(30vw);
}

.slide-enter-active {
  transition: all 0.3s ease-in;
}

.slide-leave-active {
  transition: all 0.3s ease-in;
}
.slide-leave-to {
  transform: translateX(30vw);
}

.slide-two-enter {
  transform: translateX(30vw);
}

.slide-two-enter-active {
  transition: all 0.3s ease-in;
}

.slide-two-leave-active {
  transition: all 0.3s ease-in;
}
.slide-two-leave-to {
  transform: translateX(30vw);
}
</style>



// WEBPACK FOOTER //
// src/components/empresas/Companies.vue